import { THEME_STORAGE_KEY, applyTheme, type ThemeName } from '../../tokens/theme';

/** `tokens.css` follows the system preference whenever `data-theme` is
 *  absent, so "system" is the absence of a pin rather than a third stored
 *  value. */
export type ThemeChoice = ThemeName | 'system';

export function isThemeChoice(value: string): value is ThemeChoice {
  return value === 'dark' || value === 'light' || value === 'system';
}

/** Storage throws rather than returning null in a browser configured to
 *  block site data, and anything that is not one of the two themes reads as
 *  no pin at all. */
export function readThemeChoice(): ThemeChoice {
  try {
    const value = window.localStorage.getItem(THEME_STORAGE_KEY);
    return value === 'dark' || value === 'light' ? value : 'system';
  } catch {
    return 'system';
  }
}

export function applyThemeChoice(choice: ThemeChoice): void {
  try {
    if (choice === 'system') window.localStorage.removeItem(THEME_STORAGE_KEY);
    else window.localStorage.setItem(THEME_STORAGE_KEY, choice);
  } catch {
    // Storage blocked: the choice still applies for this page.
  }
  if (choice === 'system') document.documentElement.removeAttribute('data-theme');
  else applyTheme(document.documentElement, choice);
}
